import apiClient from '@/plugins/axios'

export default {
  getProcessos() {
    return apiClient.get('processo')
  },

  getProcessosFilter(filter) {
    return apiClient.post('processo/filter', filter)
  },

  getProcesso(id) {
    return apiClient.get(`processo/${id}`)
  },

  postProcesso(processo) {
    return apiClient.post(`processo`, { processo })

  },

  putProcesso(id, processo) {
    return apiClient.put(`processo/${id}`, { processo })

  },

  deleteProcesso(id) {
    return apiClient.delete(`processo/${id}`)

  },

  getPagination(url) {
    return apiClient.get(url)
  },

  postPagination(url, filter) {
    return apiClient.post(url, filter)
  },

  getPendenciaProcesso(filter) {
    return apiClient.post(`pendenciasDoProcesso/pendencias`, { filter })
  }

}


// WEBPACK FOOTER //
// ./src/views/Processo/_services/ProcessoService.js